import { render, staticRenderFns } from "./StoreMetadataDetailPage.vue?vue&type=template&id=a220caa0"
import script from "./StoreMetadataDetailPage.vue?vue&type=script&lang=ts"
export * from "./StoreMetadataDetailPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports